import { ComponentType } from '@/configuration/component/component-types'

const PlantStatusSummaryKeys = {
    [ComponentType.Generator]: 'PLANT_STATUS_SUMMARY_GENERATOR_ID',
    [ComponentType.Transformer]: 'PLANT_STATUS_SUMMARY_TRANSFORMER_ID',
} as const

export const setComponentPlantGroupSid = (key: keyof typeof PlantStatusSummaryKeys, value: number | undefined) => {
    localStorage.setItem(PlantStatusSummaryKeys[key], value?.toString() ?? '')
}

export const getComponentPlantGroupSid = (key: keyof typeof PlantStatusSummaryKeys) => {
    const storedValue = localStorage.getItem(PlantStatusSummaryKeys[key])

    return storedValue ? parseInt(storedValue) : undefined
}